<template>
  <div class="datePicker">
    <el-date-picker
      size="small"
      v-model="value"
      type="datetimerange"
      :picker-options="pickerOptions"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      :align="align"
      @change="confirmDate"
    >
    </el-date-picker>
  </div>
</template>

<script>
export default {
  name: "datePicker",
  props: {
    //天数
    disabledDateNum: {
      type: Number,
    },
    disabledDate: {
      type: Boolean,
      default() {
        return false;
      },
    },
    dateValue: {
      type: Array,
      default() {
        return [];
      },
    },
    pickerOptions: {
      type: Object,
      default() {
        return {
          onPick: ({ maxDate, minDate }) => {
            this.choiceDate = minDate.getTime();
            if (maxDate) {
              this.choiceDate = "";
            }
          },
          disabledDate: (time) => {
            if (!this.disabledDate) {
              return;
            }
            let choiceDateTime = new Date(this.choiceDate).getTime();
            const minTime =
              choiceDateTime - 3600 * 1000 * 24 * this.disabledDateNum;
            const maxTime =
              choiceDateTime + 3600 * 1000 * 24 * this.disabledDateNum;
            const min = minTime;
            const newDate =
              new Date(new Date().toLocaleDateString()).getTime() +
              24 * 60 * 60 * 1000 -
              1;
            const max = newDate < maxTime ? newDate : maxTime;
            //如果已经选中一个日期 则 返回 该日期前后一个月时间可选
            if (this.choiceDate) {
              return time.getTime() < min || time.getTime() > max;
            }
            //若一个日期也没选中 则 返回 当前日期以前日期可选
            return time.getTime() > newDate;
          },
          shortcuts: [
            {
              text: "最近1分钟",
              onClick: (picker) => {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 60 * 1000);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近5分钟",
              onClick: (picker) => {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 60 * 1000 * 5);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近10分钟",
              onClick: (picker) => {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 60 * 1000 * 10);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近半小时",
              onClick: (picker) => {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 60 * 1000 * 30);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近6小时",
              onClick: (picker) => {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 6);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近12小时",
              onClick: (picker) => {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 12);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近24小时",
              onClick: (picker) => {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近3天",
              onClick: (picker) => {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近7天",
              onClick: (picker) => {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近14天",
              onClick: (picker) => {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
                picker.$emit("pick", [start, end]);
              },
            },
          ],
        };
      },
    },
    align: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      value: this.dateValue,
    };
  },
  methods: {
    confirmDate(date) {
      let mix = null;
      let max = null;
      if (date) {
        mix = this.timeFormat(date[0]);
        max = this.timeFormat(date[1]);
      }
      this.$emit("confirmDate", mix, max);
    },
    timeFormat(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var second = date.getSeconds();
      second = second < 10 ? "0" + second : second;
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
    },
  },
  watch: {
    dateValue() {
      //自动更新时间
      this.value = this.dateValue;
    },
  },
};
</script>

<style >

</style>



// WEBPACK FOOTER //
// src/components/datePicker.vue